import user1 from '../../../assets/images/users/1.jpg';
import user2 from '../../../assets/images/users/2.jpg';
import user3 from '../../../assets/images/users/3.jpg';
import user4 from '../../../assets/images/users/4.jpg';
import user5 from '../../../assets/images/users/5.jpg';
import user6 from '../../../assets/images/users/6.jpg';

const messages = [
  {
    id: 1,
    image: user1,
    status: 'online',
    title: 'Pavan Kumar',
    desc: 'Just send my admin!',
    time: '9:10 PM'
  },
  {
    id: 2,
    image: user2,
    status: 'busy',
    title: 'Sonu Nigam',
    desc: "I've sung a song! See you at",
    time: '9:02 AM'
  },
  {
    id: 3,
    image: user3,
    status: 'away',
    title: 'Arijit Sinh',
    desc: 'I am a singer!',
    time: '9:02 AM'
  },
  {
    id: 4,
    image: user4,
    status: 'offline',
    title: 'Pavan kumar',
    desc: 'You can customize this template as you want.',
    time: '9:08 AM'
  },
  {
    id: 5,
    image: user5,
    status: 'online',
    title: 'Pavan Kumar',
    desc: 'Just send my admin!',
    time: '9:10 PM'
  },
  {
    id: 6,
    image: user6,
    status: 'busy',
    title: 'Sonu Nigam',
    desc: "I've sung a song! See you at",
    time: '9:02 AM'
  },
  {
    id: 7,
    image: user1,
    status: 'busy',
    title: 'Mitesh Kumar',
    desc: 'Just send my admin!',
    time: '10:10 PM'
  }
];

export { messages };
